import React from 'react';

import { FlashContext } from 'providers';

export const useFlash = () => {
  const { state, ...rest } = React.useContext(FlashContext);

  return {
    flash: state.flash,
    ...rest,
  };
};
